import { codeMasterType } from "../../config/constants";
import codeMasterModel from "../common/code-master.model";
import modelBaseV2 from "../model-base-v2.model";

let taskTemplateModel = {
  getTaskTemplateList: function (filter) {
    let urlParams = modelBaseV2.toQueryString({
      TaskTemplateName: filter.templateName,
      Permission: filter.selectedPermissions.map(p => p.code).join('^'),
      PageIndex: filter.pageIndex,
      PageSize: filter.pageSize,
      UserId: filter.selectedUsers.map(u => u.userID).join('^'),
      UserRoleCode: filter.selectedUserRoles.map(r => r.code).join('^'),
      SiteId: filter.selectedSites.map(r => r.code).join('^'),
      SiteGroupId: filter.selectedSiteGroups.map(r => r.code).join('^'),
      IsBCPTemplate: filter.selectedBcpTemplate?.code
    });
    return modelBaseV2.get('/api/task/taskTemplate?' + urlParams);
  },
  saveTaskTemplate: function (params) {
    return modelBaseV2.post('/api/task/taskTemplate/create', { body: params });
  },
  editTaskTemplate: function (params) {
    return modelBaseV2.post('/api/task/taskTemplate/edit/' + params.taskTemplateMstId, { body: params });
  },
  getTemplateDetailById: function (id) {
    return modelBaseV2.get('/api/task/taskTemplate/' + id);
  },
  getTemplateBCPOptions: function () {
    return codeMasterModel.getByCategoryV2({ category: codeMasterType.bcpTemplate });
  },
}

export default taskTemplateModel;
